import { css } from 'styled-components'

export const keyframesCss = css`
  /*! CSS Used keyframes */
  @keyframes steam {
    0% {
      background-position: 0 0;
    }
    50% {
      background-position: 400% 0;
    }
    100% {
      background-position: 0 0;
    }
  }
`
